import { Navigate, Route, Routes } from "react-router-dom";
import MainAccountOnly from "components/MainAccountOnly/MainAccountOnly";
import Loader from "components/Loader/Loader";
import {MainLayout} from "components/Layout/MainLayout";
import PurchasesHistory from "views/PurchasesHistory/PurchasesHistory";
import Plans from "views/Plans/Plans";

function App() {
  return (
    <div>
      <Loader />
      <MainAccountOnly>
        <MainLayout>
          <Routes>
            <Route path="/" element={ <Navigate to="planes" /> } />
            <Route path="/planes" element={ <Plans /> } />
            <Route path="/historialCompras" element={ <PurchasesHistory /> } />
            </Routes>
        </MainLayout>
      </MainAccountOnly>
    </div>
  );
}

export default App;
